import { useEffect } from 'react';
import type { EmailLogEntry } from '../../types/email';

const EVERY_MS = 3000;

/** Re-fetch every few seconds while any shown email is still waiting to send, so it turns Sent or Failed on its own. */
export function useRefreshWhileSending(items: EmailLogEntry[] | undefined, refresh: () => void) {
  const waiting = !!items?.some(i => i.status === 'sending');
  useEffect(() => {
    if (!waiting) return undefined;
    const t = setTimeout(refresh, EVERY_MS);
    return () => clearTimeout(t);
  }, [waiting, items, refresh]);
}
